module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_8.7a18a2ed.png";